export default "__VITE_ASSET__DteoLE_S__"